import { AppProviders } from '@core/providers'
import { ENABLE_MSW } from '@core/runtime-config'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource-variable/manrope'
import '@fontsource/ibm-plex-mono/500.css'
import '@fontsource/ibm-plex-mono/600.css'
import './index.css'

// Inicializar MSW se habilitado
async function enableMocking() {
  if (ENABLE_MSW) {
    const { worker } = await import('./mocks/browser')
    return worker.start({
      onUnhandledFrame: 'bypass',
    })
  }
}

enableMocking().then(() => {
  const rootElement = document.getElementById('root')
  if (!rootElement) throw new Error('Root element not found')

  createRoot(rootElement).render(
    <StrictMode>
      <AppProviders />
    </StrictMode>,
  )
})
